import {
  type Dispatch,
  type ReactElement,
  type SetStateAction,
  useState,
} from 'react'

/**
 * `React.useState` but as a render prop
 */
export function UseState<T>(props: {
  initial?: T
  children: (
    state: T | undefined,
    setState: Dispatch<SetStateAction<T | undefined>>,
  ) => ReactElement
}) {
  const [state, setState] = useState<T | undefined>(props.initial)

  return props.children(state, setState)
}
